document.getElementById('custom-klaviyo-form').addEventListener('submit', async function(e) {
  e.preventDefault();

  const email = document.getElementById('klaviyo-email').value;
  const firstName = document.getElementById('klaviyo-first-name').value;
  const listId = document.getElementById('klaviyo-list-id').value;
  const companyId = 'Y8wUq6'; // Replace with your Klaviyo Public API Key (e.g., ABc123)

  // Get website region from domain (be, nl, de, fr)
  const hostname = window.location.hostname;
  const region = hostname.split('.').pop();
  
  // Get user's language from Shopify
  const language = Shopify?.locale || document.documentElement.lang || 'en';
  
  // Combine region-language (e.g., be-nl, fr-en, nl-nl, de-de)
  const locale = `${region}-${language}`;

  // Get location from IP (no permission needed, like Klaviyo)
  let location = 'Unknown';
  let ipAddress = '';
  try {
    const ipResponse = await fetch('https://ipapi.co/json/');
    const ipData = await ipResponse.json();
    const city = ipData.city || '';
    const country = ipData.country_name || '';
    ipAddress = ipData.ip || '';
    location = city && country ? `${city}, ${country}` : (city || country || 'Unknown');
    console.log(location, 'location');
    console.log(ipAddress, 'IP address');
  } catch (error) {
    console.log('IP geolocation not available:', error);
  }

  const options = {
    method: 'POST',
    headers: {
      'revision': '2024-10-15', // Use Klaviyo's stable API version
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { 
                email: email, 
                first_name: firstName,
                location: {
                  ip: ipAddress
                },
                properties: {
                  location: location,
                  locale: locale
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    })
  };

  try {
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, options);
    
    if (response.status === 202) {
      // Success! Klaviyo accepted the subscription (usually returns 202 Accepted)
      document.getElementById('custom-klaviyo-form').style.display = 'none';
      document.querySelector('.klaviyo-signup__content').style.display = 'none';
      document.getElementById('form-success').style.display = 'flex';
      
      // Optional: Push to Klaviyo onsite tracking object if you also want to track the session browser-side
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Subscribed via Custom Form']);
      }
    } else {
      throw new Error('Klaviyo API responded with an error status');
    }
  } catch (err) {
    console.error('Subscription error:', err);
    document.getElementById('form-error').style.display = 'block';
  }
});